var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-card",class:{ hidden: !_vm.isCardVisible || _vm.isCardVisible === 'volontaryHide' }},[_c('p',{staticClass:"centered-text"},[_vm._v(_vm._s(_vm.bannerText))]),_c('span',{staticClass:"close-btn",on:{"click":_vm.closeCard}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }